const MINIMUM_RATING_TO_DISPLAY = 4;

export { MINIMUM_RATING_TO_DISPLAY };
